import React from 'react'

import { ErrorMessage as HookFormErrorMessage } from '@hookform/error-message'
import _ from 'lodash'
import { useFormContext } from 'react-hook-form'

const ErrorMessage = ({ id, name }) => {
  const {
    formState: { errors }
  } = useFormContext()

  const getMessage = () => {
    const error = _.get(errors, name)
    if (!error) return ''

    switch (error.type) {
      case 'required':
        return 'Este campo é obrigatório'
      case 'min':
        return 'Valor inserido é abaixo do mínimo permitido'
      case 'max':
        return 'Valor inserido é acima do máximo permitido'
      default:
        return 'Este campo está inválido, verifique e tente novamente'
    }
  }

  return (
    <HookFormErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => (
        // `text-danger` (#f64e60) dá 3.40:1 — reprova como texto. A variante
        // `-text` existe justamente para este caso (ACCESSIBILITY.md §1.3).
        // `role="alert"` para o erro ser anunciado quando aparece, além de
        // ficar referenciado pelo campo via aria-describedby.
        <span id={id} role="alert" className="block text-xs text-danger-text mt-1">
          {message ? message : getMessage()}
        </span>
      )}
    />
  )
}

export { ErrorMessage }
export default ErrorMessage
